export const AppHeaders = {
  RecaptchaToken: "Recaptcha-Token",
};

export const initHeaders = (key: string, value: string): Headers => {
  const headers = new Headers();
  headers.set(key, value);
  return headers;
};
